"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExpandableTags = exports.expandableTags = void 0;
const react_1 = require("react");
exports.expandableTags = ['tag/analyses', 'tag/in-tray-sources', 'tag/metrics', 'tag/analyses-webhooks'];
const useExpandableTags = (isLoaded) => {
    (0, react_1.useEffect)(() => {
        let observer = null;
        if (isLoaded) {
            const target = document.querySelector('.menu-content');
            if (target) {
                observer = new MutationObserver(() => {
                    exports.expandableTags.forEach((expandableTag) => {
                        const isOpen = location.hash.startsWith(`#${expandableTag}`);
                        const tagEl = document.querySelector(`[data-item-id="${expandableTag}"]`);
                        tagEl === null || tagEl === void 0 ? void 0 : tagEl.classList.toggle('open', isOpen);
                    });
                });
                observer.observe(target, { childList: true, subtree: true, attributes: true });
            }
        }
        return () => {
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
    }, [isLoaded]);
};
exports.useExpandableTags = useExpandableTags;
